function renderDots(value, max = 4) {
  return Array.from(
    { length: max },
    (_, i) => `<span class="glb-card__content-activity-value-dot${i < value ? ' active' : ''}"></span>`
  ).join('');
}

function renderActivityIcons(activities) {
  return activities
    .map(
      ({ icon, value, name }) => `
    <div class="glb-card__content-activity">
      <img src="${icon}" alt="${name} Icon" class="glb-card__content-activity-icon">
      <div class="glb-card__content-activity-value">
        <span class="glb-card__content-activity-value-text">${name}</span>
        <div>${renderDots(value)}</div>
      </div>
    </div>
  `
    )
    .join('');
}

function renderInfoCard(country) {
  const { name, icon, product } = country;

  return `
    <div class="glb-card__content-image">
      <img class="glb-card__content-country-icon" src="${icon}" alt="${name} Icon">
      <img class="glb-card__content-country-image" src="${product.card_image}" alt="${product.card_title} Image">
    </div>
    <div class="glb-card__content-text">
      <h3 class="glb-card__content-country-name">${product.card_title}</h3>
      <div class="glb-card__content-activities">
        ${renderActivityIcons(product.activity)}
      </div>
   <a href="${product.url}" class="button button--primary glb-card__content-button">
          Scopri di più
        </a>
    </div>
  `;
}

function openInfoCard(country) {
  const cardsContainer = document.querySelector('.glb-cards-container');
  if (!cardsContainer) {
    console.error('🌍 Globe Debug - Cards container non trovato');
    return;
  }

  // Trova tutti i paesi con lo stesso nome
  const allCountriesData = JSON.parse(document.getElementById('glb-data')?.textContent) || [];
  const countriesWithSameName = allCountriesData.filter(
    (c) => c.name.trim().toLowerCase() === country.name.trim().toLowerCase()
  );

  // Pulisci il container
  cardsContainer.innerHTML = '';

  if (countriesWithSameName.length === 1) {
    showSingleCard(countriesWithSameName[0], cardsContainer);
  } else {
    showMultipleCards(countriesWithSameName, cardsContainer);
  }
}

function closeInfoCard(world, initialView) {
  const cardsContainer = document.querySelector('.glb-cards-container');
  if (cardsContainer) {
    cardsContainer.innerHTML = '';
  }

  if (world && initialView) {
    world.pointOfView(initialView, 1000);
  }
}

function showSingleCard(country, container) {
  const cardsStack = document.createElement('div');
  cardsStack.className = 'glb-cards-stack';
  container.appendChild(cardsStack);

  const card = document.createElement('div');
  card.className = 'glb-card';
  card.dataset.blockId = country.blockId;
  card.innerHTML = `
    <div class="glb-card__content">
      ${renderInfoCard(country)}
    </div>
  `;
  cardsStack.appendChild(card);

  card.classList.add('glb-card--current');
}

function showMultipleCards(countries, container) {
  const cardsStack = document.createElement('div');
  cardsStack.className = 'glb-cards-stack';
  container.appendChild(cardsStack);

  countries.forEach((country) => {
    const card = document.createElement('div');
    card.className = 'glb-card glb-card--multiple';
    card.dataset.blockId = country.blockId;
    card.innerHTML = `
      <div class="glb-card__content">
        ${renderInfoCard(country)}
      </div>
    `;
    cardsStack.appendChild(card);
  });

  const cards = cardsStack.querySelectorAll('.glb-card');
  cards.forEach((card, index) => {
    if (index === 0) {
      card.classList.add('glb-card--current');
    } else if (index === 1) {
      card.classList.add('glb-card--next');
    }
  });

  addSwipeListeners(countries, cardsStack);
  addCardNavigation(countries, cardsStack);
}

function addSwipeListeners(countries, cardsStack) {
  if (cardsStack.hasAttribute('data-swipe-listeners-added')) {
    return;
  }
  cardsStack.setAttribute('data-swipe-listeners-added', 'true');

  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let mouseDownTime = 0;
  let mouseMoved = false;
  let dragHandled = false;

  // Touch events
  cardsStack.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = false;
      dragHandled = false;
    },
    { passive: true }
  );

  cardsStack.addEventListener(
    'touchmove',
    (e) => {
      if (!isDragging) {
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = Math.abs(currentX - startX);
        const diffY = Math.abs(currentY - startY);

        if (diffX > diffY && diffX > 10) {
          isDragging = true;
        }
      }
    },
    { passive: true }
  );

  cardsStack.addEventListener(
    'touchend',
    (e) => {
      if (isDragging) {
        const endX = e.changedTouches[0].clientX;
        const diffX = endX - startX;

        if (Math.abs(diffX) > 50) {
          dragHandled = true;

          if (diffX > 0) {
            goToPreviousCard(countries, cardsStack);
          } else {
            goToNextCard(countries, cardsStack);
          }
        }
      }
      isDragging = false;
    },
    { passive: true }
  );

  // Mouse events
  cardsStack.addEventListener('mousedown', (e) => {
    startX = e.clientX;
    startY = e.clientY;
    isDragging = false;
    mouseDownTime = Date.now();
    mouseMoved = false;
    dragHandled = false;
  });

  cardsStack.addEventListener('mousemove', (e) => {
    if (e.buttons === 1) {
      mouseMoved = true;
      if (!isDragging) {
        const diffX = Math.abs(e.clientX - startX);
        const diffY = Math.abs(e.clientY - startY);

        if (diffX > diffY && diffX > 10) {
          isDragging = true;
        }
      }
    }
  });

  cardsStack.addEventListener('mouseup', (e) => {
    if (isDragging && mouseMoved) {
      const endX = e.clientX;
      const diffX = endX - startX;

      if (Math.abs(diffX) > 50) {
        dragHandled = true;

        if (diffX > 0) {
          goToPreviousCard(countries, cardsStack);
        } else {
          goToNextCard(countries, cardsStack);
        }
      }
    }
    isDragging = false;
    mouseMoved = false;
  });

  cardsStack.addEventListener('selectstart', (e) => {
    e.preventDefault();
  });

  cardsStack.addEventListener('dragstart', (e) => {
    e.preventDefault();
  });

  cardsStack.addEventListener('click', (e) => {
    if (dragHandled) {
      dragHandled = false;
      return;
    }

    const card = e.target.closest('.glb-card');
    if (card) {
      const blockId = card.dataset.blockId;
      const country = countries.find((c) => c.blockId === blockId);

      if (country) {
        updateCardStack(countries, country, cardsStack);
      }
    }
  });
}

function goToNextCard(countries, cardsStack) {
  const currentCard = cardsStack.querySelector('.glb-card--current');
  if (!currentCard) return;

  const currentIndex = countries.findIndex((c) => c.blockId === currentCard.dataset.blockId);
  const nextIndex = (currentIndex + 1) % countries.length;
  const nextCountry = countries[nextIndex];

  updateCardStack(countries, nextCountry, cardsStack);
}

function goToPreviousCard(countries, cardsStack) {
  const currentCard = cardsStack.querySelector('.glb-card--current');
  if (!currentCard) return;

  const currentIndex = countries.findIndex((c) => c.blockId === currentCard.dataset.blockId);
  const prevIndex = currentIndex === 0 ? countries.length - 1 : currentIndex - 1;
  const prevCountry = countries[prevIndex];

  updateCardStack(countries, prevCountry, cardsStack);
}

function addCardNavigation(countries, cardsStack) {
  if (!cardsStack) return;

  if (cardsStack.querySelector('.glb-card-nav')) return;

  const cards = cardsStack.querySelectorAll('.glb-card');
  if (cards.length <= 1) return;

  const nav = document.createElement('div');
  nav.className = 'glb-card-nav';

  nav.innerHTML = `
  <div class="glb-card-nav__zone glb-card-nav__zone--prev">
    <button type="button" class="glb-card-nav__btn glb-card-nav__btn--prev" aria-label="Card precedente">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 7L10 12L15 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </button>
  </div>

  <div class="glb-card-nav__meta" aria-hidden="true">
    <span class="glb-card-nav__label">Viaggi disponibili</span>
    <span class="glb-card-nav__count">1 di ${cards.length}</span>
  </div>

  <div class="glb-card-nav__zone glb-card-nav__zone--next">
    <button type="button" class="glb-card-nav__btn glb-card-nav__btn--next" aria-label="Card successiva">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 7L14 12L9 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </button>
  </div>
`;

  nav.addEventListener('click', (e) => e.stopPropagation());

  const prevBtn = nav.querySelector('.glb-card-nav__btn--prev');
  const nextBtn = nav.querySelector('.glb-card-nav__btn--next');

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    goToPreviousCard(countries, cardsStack);
  });

  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    goToNextCard(countries, cardsStack);
  });

  cardsStack.appendChild(nav);
  updateCardNavMeta(countries, cardsStack);
  hideNavMetaAfter(cardsStack, 2500);
  window.addEventListener('resize', () => updateCardNavMeta(countries, cardsStack));
}

function getCurrentCardIndex(countries, cardsStack) {
  const current = cardsStack.querySelector('.glb-card--current');
  if (!current) return 0;
  const id = current.dataset.blockId;
  const idx = countries.findIndex((c) => c.blockId === id);
  return idx >= 0 ? idx : 0;
}

function updateCardNavMeta(countries, cardsStack) {
  const meta = cardsStack.querySelector('.glb-card-nav__meta');
  if (!meta) return;

  meta.classList.remove('is-hidden');

  const countEl = meta.querySelector('.glb-card-nav__count');
  const hintEl = meta.querySelector('.glb-card-nav__hint');

  const idx = getCurrentCardIndex(countries, cardsStack);
  if (countEl) countEl.textContent = `${idx + 1} di ${countries.length}`;

  const isTouch = window.matchMedia('(pointer: coarse)').matches;
  if (hintEl) hintEl.textContent = isTouch ? 'Trascina' : '← →';
}

function hideNavMetaAfter(cardsStack, delay = 2500) {
  const meta = cardsStack.querySelector('.glb-card-nav__meta');
  if (!meta) return;

  // reset visibilità e timer precedente
  meta.classList.remove('is-hidden');
  if (cardsStack._navMetaTimer) clearTimeout(cardsStack._navMetaTimer);

  cardsStack._navMetaTimer = setTimeout(() => {
    meta.classList.add('is-hidden');
  }, delay);
}

function updateCardStack(countries, selectedCountry, cardsStack) {
  const currentCard = cardsStack.querySelector('.glb-card--current');
  const nextCard = cardsStack.querySelector(`[data-block-id="${selectedCountry.blockId}"].glb-card`);

  if (currentCard && nextCard && currentCard !== nextCard) {
    const cards = cardsStack.querySelectorAll('.glb-card');

    cards.forEach((card) => card.classList.remove('glb-card--current', 'glb-card--out', 'glb-card--next'));
    void cardsStack.offsetWidth;

    currentCard.classList.add('glb-card--out');
    nextCard.classList.add('glb-card--current');

    const nextIndex = Array.from(cards).indexOf(nextCard) + 1;
    const nextNextCard = cards[nextIndex] || cards[0];
    nextNextCard.classList.add('glb-card--next');

    updateCardNavMeta(countries, cardsStack);
    hideNavMetaAfter(cardsStack, 1200);
  }
}

const getPolygonCenter = (geometry) => {
  let latSum = 0,
    lngSum = 0,
    count = 0;

  const extract = (coords) => {
    coords.forEach((ring) =>
      ring.forEach(([lng, lat]) => {
        latSum += lat;
        lngSum += lng;
        count++;
      })
    );
  };

  if (geometry.type === 'Polygon') {
    extract(geometry.coordinates.slice(0, 1));
  } else if (geometry.type === 'MultiPolygon') {
    geometry.coordinates.forEach((polygon) => extract(polygon.slice(0, 1)));
  }

  return {
    lat: latSum / count,
    lng: lngSum / count,
  };
};

(function () {
  const globeElement = document.getElementById('globeViz');

  let countriesData = [];
  const dataEl = document.getElementById('glb-data');

  if (dataEl) {
    try {
      countriesData = JSON.parse(dataEl.textContent) || [];

      countriesData.forEach((country) => {
        if (country?.product?.card_image) {
          const img = new Image();
          img.src = country.product.card_image;
        }

        if (country?.icon) {
          const iconImg = new Image();
          iconImg.src = country.icon;
        }
      });
    } catch (err) {
      console.warn('🌍 Globe Debug - Errore parsing glb-data o preload immagini:', err);
      countriesData = [];
    }
  }

  const geojsonUrl =
    'https://cdn.shopify.com/s/files/1/0906/3756/6286/files/ne_110m_admin_0_countries.geojson?v=1751387178';

  const selectedCountries = countriesData.map((country) => country.name);

  fetch(geojsonUrl)
    .then((res) => res.json())
    .then((countries) => {
      const allFeatures = countries.features;
      const isMobile = window.innerWidth <= 768;

      const initialView = isMobile ? { lat: 25, lng: 10, altitude: 3 } : { lat: 25, lng: 10, altitude: 1.9 };

      const world = new window.Globe()(globeElement)
        .globeImageUrl('https://cdn.shopify.com/s/files/1/0776/1883/9847/files/globo_sfondo_viandar.jpg?v=1752742181')
        .backgroundColor('#ffffff')
        .showAtmosphere(false)
        .atmosphereColor('#b14028')
        .atmosphereAltitude(0.2)
        .showGraticules(false)
        .polygonsData(allFeatures)
        .polygonCapColor((d) => (selectedCountries.includes(d.properties.ADMIN) ? '#B14028' : 'rgba(229, 229, 229, 0)'))
        .polygonStrokeColor((d) => (selectedCountries.includes(d.properties.ADMIN) ? '#ffcc00' : '#ccc'))
        .polygonSideColor((d) =>
          selectedCountries.includes(d.properties.ADMIN) ? 'rgba(255,204,0,0.2)' : 'rgba(0,0,0,0)'
        )
        .polygonAltitude((d) => (selectedCountries.includes(d.properties.ADMIN) ? 0.01 : 0))
        .polygonsTransitionDuration(400)
        .polygonLabel((d) => (selectedCountries.includes(d.properties.ADMIN) ? `<b>${d.properties.ADMIN}</b>` : null))
        .onPolygonClick((d) => {
          if (!selectedCountries.includes(d.properties.ADMIN)) {
            closeInfoCard(world, initialView);
            return;
          }

          const { lat, lng } = getPolygonCenter(d.geometry);
          world.pointOfView({ lat, lng, altitude: 1.6 }, 1000);

          let selected = countriesData.find(
            (country) => country.name.trim().toLowerCase() === d.properties.ADMIN.trim().toLowerCase()
          );

          if (!selected) {
            selected = countriesData.find(
              (country) =>
                country.name.trim().toLowerCase().replace(/\s+/g, '') ===
                d.properties.ADMIN.trim().toLowerCase().replace(/\s+/g, '')
            );
          }

          if (!selected && d.properties.ADMIN.trim().length > 3) {
            selected = countriesData.find((country) => {
              const countryName = country.name.trim().toLowerCase();
              const geoName = d.properties.ADMIN.trim().toLowerCase();

              return (
                (countryName.includes(geoName) && geoName.length >= 4) ||
                (geoName.includes(countryName) && countryName.length >= 4)
              );
            });
          }

          if (!selected) {
            return;
          }

          openInfoCard(selected);
        })
        .onGlobeClick(() => closeInfoCard(world, initialView));

      const glbSection = document.getElementById('glb-section');
      if (glbSection) {
        glbSection.addEventListener('click', (e) => {
          const cardsContainer = glbSection.querySelector('.glb-cards-container');
          const clickInsideCards = cardsContainer && cardsContainer.contains(e.target);

          const rect = globeElement.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          const coordsOnGlobe = world.toGlobeCoords(x, y);
          const clickOnGlobe = !!coordsOnGlobe;

          if (!clickOnGlobe && !clickInsideCards) {
            closeInfoCard(world, initialView);
          }
        });
      }

      function resizeGlobe() {
        const height = window.innerHeight * 1.2; // 120vh
        world.height(height);
        world.width(globeElement.clientWidth);
      }

      resizeGlobe();
      window.addEventListener('resize', resizeGlobe);

      world.pointOfView(initialView);
      world.controls().enableZoom = false;
    })
    .catch((error) => {
      console.error('🌍 Globe Debug - Errore caricamento GeoJSON:', error);
    });
})();
